import { useEffect } from 'react';

interface Props {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}

export default function LegalModal({ title, children, onClose }: Props) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#0A2540]/10">
          <h2 className="text-lg font-bold text-[#0A2540]">{title}</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-[#F7F9FC] text-[#0A2540]/60 hover:text-[#0A2540] transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>
        <div className="px-6 py-5 overflow-y-auto flex-1">
          {children}
        </div>
        <div className="px-6 py-3 border-t border-[#0A2540]/10 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#2C7DA0] hover:bg-[#1a5a7a] text-white text-sm rounded-lg transition-colors cursor-pointer"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
